{
  "pt": {
    "countries": {
      "ABW": "Aruba",
      "AFG": "Afeganistão",
      "AFI": "Afars e Issas",
      "AGO": "Angola",
      "AIA": "Anguila",
      "ALA": "Ilhas Åland",
      "ALB": "Albânia",
      "AND": "Andorra",
      "ANT": "Antilhas Neerlandesas",
      "ARE": "Emirados Árabes Unidos",
      "ARG": "Argentina",
      "ARM": "Arménia",
      "ASM": "Samoa Americana",
      "ATA": "Antártida",
      "ATB": "Território Antártico Britânico",
      "ATF": "Territórios Franceses do Sul",
      "ATG": "Antígua e Barbuda",
      "ATN": "Terra da Rainha Maud",
      "AUS": "Austrália",
      "AUT": "Áustria",
      "AZE": "Azerbaijão",
      "BDI": "Burundi",
      "BEL": "Bélgica",
      "BEN": "Benim",
      "BES": "Bonaire, Santo Eustáquio e Saba",
      "BFA": "Burquina Faso",
      "BGD": "Bangladesh",
      "BGR": "Bulgária",
      "BHR": "Barém",
      "BHS": "Bahamas",
      "BIH": "Bósnia e Herzegovina",
      "BLM": "Saint-Barthélemy",
      "BLR": "Bielorrússia",
      "BLZ": "Belize",
      "BMU": "Bermudas",
      "BOL": "Bolívia",
      "BRA": "Brasil",
      "BRB": "Barbados",
      "BRN": "Brunei Darussalam",
      "BTN": "Butão",
      "BUR": "Birmânia",
      "BVT": "Ilha Bouvet",
      "BWA": "Botsuana",
      "BYS": "Bielorrússia",
      "CAF": "República Centro-Africana",
      "CAN": "Canadá",
      "CCK": "Ilhas Cocos (Keeling)",
      "CHE": "Suíça",
      "CHL": "Chile",
      "CHN": "China",
      "CIV": "Costa do Marfim",
      "CMR": "Camarões",
      "COD": "Congo",
      "COG": "Congo",
      "COK": "Ilhas Cook",
      "COL": "Colômbia",
      "COM": "Comores",
      "CPV": "Cabo Verde",
      "CRI": "Costa Rica",
      "CSK": "Checoslováquia",
      "CTE": "Ilhas de Cantão e Enderbury",
      "CUB": "Cuba",
      "CUW": "Curaçao",
      "CXR": "Ilha do Natal",
      "CYM": "Ilhas Caimão",
      "CYP": "Chipre",
      "CZE": "República Checa",
      "DDR": "Alemanha de Leste",
      "DEU": "Alemanha",
      "DHY": "Daomé",
      "DJI": "Jibuti",
      "DMA": "Domínica",
      "DNK": "Dinamarca",
      "DOM": "República Dominicana",
      "DZA": "Argélia",
      "ECU": "Equador",
      "EGY": "Egipto",
      "ERI": "Eritreia",
      "ESH": "Saara Ocidental",
      "ESP": "Espanha",
      "EST": "Estónia",
      "ETH": "Etiópia",
      "FIN": "Finlândia",
      "FJI": "Fiji",
      "FLK": "Ilhas Falkland (Malvinas)",
      "FRA": "França",
      "FRO": "Ilhas Faroé",
      "FSM": "Micronésia",
      "FXX": "França metropolitana",
      "GAB": "Gabão",
      "GBR": "Reino Unido",
      "GEL": "Ilhas Gilbert",
      "GEO": "Geórgia",
      "GGY": "Guernsey",
      "GHA": "Gana",
      "GIB": "Gibraltar",
      "GIN": "Guiné",
      "GLP": "Guadalupe",
      "GMB": "Gâmbia",
      "GNB": "Guiné-Bissau",
      "GNQ": "Guiné Equatorial",
      "GRC": "Grécia",
      "GRD": "Granada",
      "GRL": "Gronelândia",
      "GTM": "Guatemala",
      "GUF": "Guiana Francesa",
      "GUM": "Guame",
      "GUY": "Guiana",
      "HKG": "Hong Kong",
      "HMD": "Ilha Heard e Ilhas Mcdonald",
      "HND": "Honduras",
      "HRV": "Croácia",
      "HTI": "Haiti",
      "HUN": "Hungria",
      "HVO": "Alto Volta",
      "IDN": "Indonésia",
      "IMN": "Ilha de Man",
      "IND": "Índia",
      "IOT": "Território britânico do Oceano Índico",
      "IRL": "Irlanda",
      "IRN": "Irão",
      "IRQ": "Iraque",
      "ISL": "Islândia",
      "ISR": "Israel",
      "ITA": "Itália",
      "JAM": "Jamaica",
      "JEY": "Jersey",
      "JOR": "Jordânia",
      "JPN": "Japão",
      "JTN": "Ilha Johnston",
      "KAZ": "Cazaquistão",
      "KEN": "Quénia",
      "KGZ": "Quirguizistão",
      "KHM": "Camboja",
      "KIR": "Kiribati",
      "KNA": "São Cristóvão, Neves e Anguila",
      "KOR": "Coreia do Sul",
      "KWT": "Kuwait",
      "LAO": "Laos",
      "LBN": "Líbano",
      "LBR": "Libéria",
      "LBY": "Líbia",
      "LCA": "Santa Lúcia",
      "LIE": "Liechtenstein",
      "LKA": "Sri Lanka",
      "LSO": "Lesoto",
      "LTU": "Lituânia",
      "LUX": "Luxemburgo",
      "LVA": "Letónia",
      "MAC": "Macau",
      "MAF": "São Martinho (parte francesa)",
      "MAR": "Marrocos",
      "MCO": "Mónaco",
      "MDA": "Moldávia",
      "MDG": "Madagáscar",
      "MDV": "Maldivas",
      "MEX": "México",
      "MHL": "Ilhas Marshall",
      "MID": "Ilhas Midway",
      "MKD": "Macedónia",
      "MLI": "Mali",
      "MLT": "Malta",
      "MMR": "Myanmar",
      "MNE": "Montenegro",
      "MNG": "Mongólia",
      "MNP": "Ilhas Marianas do Norte",
      "MOZ": "Moçambique",
      "MRT": "Mauritânia",
      "MSR": "Montserrat",
      "MTQ": "Martinica",
      "MUS": "Maurícia",
      "MWI": "Malawi",
      "MYS": "Malásia",
      "MYT": "Mayotte",
      "NAM": "Namíbia",
      "NCL": "Nova Caledónia",
      "NER": "Níger",
      "NFK": "Ilha Norfolk",
      "NGA": "Nigéria",
      "NHB": "Novas Hébridas",
      "NIC": "Nicarágua",
      "NIU": "Niue",
      "NLD": "Países Baixos",
      "NOR": "Noruega",
      "NPL": "Nepal",
      "NRU": "Nauru",
      "NTZ": "Zona neutra",
      "NZL": "Nova Zelândia",
      "OMN": "Omã",
      "PAK": "Paquistão",
      "PAN": "Panamá",
      "PCI": "Ilhas do Pacífico (Território Fiduciário)",
      "PCN": "Pitcairn",
      "PCZ": "Zona do Canal do Panamá",
      "PER": "Peru",
      "PHI": "Filipinas",
      "PHL": "Filipinas",
      "PLW": "Palau",
      "PNG": "Papua Nova Guiné",
      "POL": "Polónia",
      "PRI": "Porto Rico",
      "PRK": "Coreia do Norte",
      "PRT": "Portugal",
      "PRY": "Paraguai",
      "PSE": "Território Palestiniano, Ocupado",
      "PUS": "Estados Unidos Diversos Ilhas do Pacífico",
      "PYF": "Polinésia Francesa",
      "QAT": "Qatar",
      "REU": "Reunião",
      "RHO": "Rodésia do Sul",
      "ROU": "Roménia",
      "RUS": "Rússia",
      "RWA": "Ruanda",
      "SAU": "Arábia Saudita",
      "SCG": "Sérvia e Montenegro",
      "SDN": "Sudão",
      "SEN": "Senegal",
      "SGP": "Singapura",
      "SGS": "Geórgia do Sul e Ilhas Sandwich do Sul",
      "SHN": "Santa Helena, Ascensão e Tristão da Cunha",
      "SJM": "Svalbard e Jan Mayen",
      "SKM": "Sikkim",
      "SLB": "Ilhas Salomão",
      "SLE": "Serra Leoa",
      "SLV": "El Salvador",
      "SMR": "São Marinho",
      "SOM": "Somália",
      "SPM": "São Pedro e Miquelon",
      "SRB": "Sérvia",
      "SSD": "Sudão do Sul",
      "STP": "São Tomé e Príncipe",
      "SUN": "URSS",
      "SUR": "Suriname",
      "SVK": "Eslováquia",
      "SVN": "Eslovénia",
      "SWE": "Suécia",
      "SWZ": "Suazilândia",
      "SXM": "São Martinho (parte neerlandesa)",
      "SYC": "Seychelles",
      "SYR": "Síria",
      "TCA": "Ilhas Turcas e Caicos",
      "TCD": "Chade",
      "TGO": "Togo",
      "THA": "Tailândia",
      "TJK": "Tajiquistão",
      "TKL": "Tokelau",
      "TKM": "Turquemenistão",
      "TLS": "Timor-Leste",
      "TMP": "Timor Português",
      "TON": "Tonga",
      "TTO": "Trinidad e Tobago",
      "TUN": "Tunísia",
      "TUR": "Turquia",
      "TUV": "Tuvalu",
      "TWN": "Taiwan, Província da China",
      "TZA": "Tanzânia",
      "UGA": "Uganda",
      "UKR": "Ucrânia",
      "UMI": "Ilhas Menores Distantes dos Estados Unidos",
      "URY": "Uruguai",
      "USA": "Estados Unidos",
      "UZB": "Uzbequistão",
      "VAT": "Cidade do Vaticano",
      "VCT": "São Vicente e Granadinas",
      "VDR": "Vietname do Norte",
      "VEN": "Venezuela",
      "VGB": "Ilhas Virgens Britânicas",
      "VIR": "Ilhas Virgens dos Estados Unidos",
      "VNM": "Vietname do Sul",
      "VUT": "Vanuatu",
      "WAK": "Ilha Wake",
      "WLF": "Wallis e Futuna",
      "WSM": "Samoa",
      "XXX": "Desconhecido",
      "YEM": "Iémen do Norte",
      "YMD": "Iémen do Sul",
      "YUG": "Jugoslávia",
      "ZAF": "África do Sul",
      "ZAR": "Zaire",
      "ZMB": "Zâmbia",
      "ZWE": "Zimbabué"
    }
  }
}
